var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-carousel',{attrs:{"height":"470px","interval":5000,"arrow":"always","trigger":"click"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"banner-img",attrs:{"src":item.img,"alt":"banner"}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef5e1de6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = null
// module chunks = 